import {
  FETCH_PRINCIPAL_REQUEST,
  FETCH_PRINCIPAL_SUCCESS,
  FETCH_PRINCIPAL_FAILURE,
  FETCH_PRINCIPAL_WITH_ID_SUCCESS,
  FETCH_PRINCIPAL_WITH_ID_FAILURE,
  FETCH_PRINCIPAL_WITH_ID_REQUEST,
  CLEAR_STORE,
} from './principalActions';

export interface PrincipalState {
  loading: boolean;
  principal_list: any;
  error: string | null;
  principal: any;
}

const initialState: PrincipalState = {
  loading: true,
  principal_list: null,
  error: null,
  principal: null,
};

interface PrincipalAction {
  type: string;
  payload?: any;
  error?: any;
}

const principalReducer = (
  state: PrincipalState = initialState,
  action: PrincipalAction,
): PrincipalState => {
  switch (action.type) {
    case FETCH_PRINCIPAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PRINCIPAL_SUCCESS:
      return {
        ...state,
        loading: false,
        principal_list: action.payload,
      };
    case FETCH_PRINCIPAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case FETCH_PRINCIPAL_WITH_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PRINCIPAL_WITH_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        principal: action.payload,
      };
    case FETCH_PRINCIPAL_WITH_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export default principalReducer;

